import { render } from "./MiningPayment.vue?vue&type=template&id=80048b06&scoped=true"
import script from "./MiningPayment.vue?vue&type=script&lang=js"
export * from "./MiningPayment.vue?vue&type=script&lang=js"

import "./MiningPayment.vue?vue&type=style&index=0&id=80048b06&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80048b06"]])

export default __exports__